module.exports = __webpack_public_path__ + "img/background_02.96ca2263.png";